module.exports = __webpack_public_path__ + "src/images/products/prep/28_Levi's Made In USA 511.png";